export default __webpack_public_path__ + "static/natalia-1aac65e61cea5dc28a3252f2c181e274.png";